import { Coordinates } from 'src/app/models/Coordinates';
import { Component, OnInit } from '@angular/core';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { Ope } from 'src/app/models/Ope';
import { MapComponent } from '../map/map.component';
@Component({
  selector: 'app-map-search',
  templateUrl: './map-search.component.html',
  imports : [MapComponent],
  styleUrls: ['./map-search.component.scss']
  //template: `<div style="position: left;"><div id="mapo"></div> </div>`
})


export class MapSearchComponent implements OnInit {

  opes!: Ope[];
  coordinatesOutPut!: Array<Coordinates>;

  constructor(public share: shareOpeSevices) {

  }
  ngOnInit(): void {

  }



}